import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
const _hoisted_2 = {
  class: "wrapped-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_popover = _resolveComponent("b-popover");
  return _openBlock(), _createElementBlock("div", {
    id: `attached-to-${$props.target}`,
    class: "wrap-with-popover-container",
    style: _normalizeStyle($props.styles)
  }, [_createVNode(_component_b_popover, {
    target: $props.target,
    modelValue: $options.localShow,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.localShow = $event),
    manual: $props.manual,
    click: $props.click,
    triggers: $props.triggers,
    customClass: `wrap-with-popover popover ${$props.customClass}`,
    placement: $props.placement,
    container: $props.container,
    boundary: $props.boundary,
    strategy: $props.strategy,
    delay: $props.delay,
    style: _normalizeStyle({
      ['--bs-popover-width']: $props.width,
      ['--bs-popover-padding']: $props.padding
    }),
    offset: $props.offset
  }, {
    title: _withCtx(() => [_renderSlot(_ctx.$slots, "title")]),
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "content")]),
    _: 3
  }, 8, ["target", "modelValue", "manual", "click", "triggers", "customClass", "placement", "container", "boundary", "strategy", "delay", "style", "offset"]), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "default")])], 12, _hoisted_1);
}